import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  MissedDeadlineDto,
  CreateAttestationRequest,
} from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson, apiVoid } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';

export function useMissedDeadlines() {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.finance.missedDeadlines(),
    queryFn: () =>
      apiJson<MissedDeadlineDto[]>('/api/finance/committee-formation/missed-deadlines', {
        error: 'Failed to fetch missed deadlines',
      }),
    enabled: authService.isAuthenticated() && !!selectedCampaign,
  });
}

export function useCreateAttestation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateAttestationRequest) =>
      apiVoid('/api/finance/committee-formation/attestations', {
        method: 'POST',
        json: data,
        error: 'Failed to create attestation',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.finance.missedDeadlines() });
      queryClient.invalidateQueries({ queryKey: queryKeys.finance.obligations() });
    },
  });
}
